import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { GovernmentOffices } from '../models/government.model';
import { Observable, catchError, of, map } from 'rxjs';
import { sortBy } from 'lodash';

const GOVERNMENT_ADDRESSES_KEY = 'governmentAddresses';
const CACHE_TTL_DAYS = 30;

@Injectable()
export class GovernmentService {
  constructor(private apiService: ApiService) {}

  public getOffices(): Observable<GovernmentOffices> {
    const storedData = this.getDataFromLocalStorage();
    if (this.shouldFetchFromEndpoint(storedData)) {
      return this.apiService.get<GovernmentOffices>('government/get', { showToast: false }).pipe(
        map((response) => {
          const sortedOffices = sortBy(response, ['officeTypeDisplayOrder', 'officeTypeName']);
          this.saveDataToLocalStorage(sortedOffices);
          return response;
        }),
        catchError((error) => {
          console.error('Error fetching data from endpoint:', error);
          return of<GovernmentOffices>(storedData as GovernmentOffices);
        })
      );
    } else {
      return of<GovernmentOffices>(storedData as GovernmentOffices);
    }
  }

  private shouldFetchFromEndpoint(storedData: any): boolean {
    const thirtyDaysAgo = new Date();
    thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - CACHE_TTL_DAYS);
    return !storedData || storedData.timestamp < thirtyDaysAgo;
  }

  private getDataFromLocalStorage(): GovernmentOffices | null {
    const storedData = localStorage.getItem(GOVERNMENT_ADDRESSES_KEY);
    return storedData ? JSON.parse(storedData)?.data : null;
  }

  private saveDataToLocalStorage(data: GovernmentOffices): void {
    const dataWithTimestamp = { data, timestamp: new Date() };
    localStorage.setItem(GOVERNMENT_ADDRESSES_KEY, JSON.stringify(dataWithTimestamp));
  }
}
